import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatChip, MatChipGrid, MatChipListbox, MatChipSet } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CdkDrag, CdkDropList, CdkDropListGroup } from '@angular/cdk/drag-drop';
import { MatTab, MatTabGroup, MatTabsModule } from '@angular/material/tabs';

export const commonImports = [
  AsyncPipe,
  ReactiveFormsModule,
  MatIconModule,
  MatButtonModule,
  MatIconButton,
  MatMenuModule,
  NgFor,
  NgIf,
  MatAutocompleteModule,
  MatChip,
  MatChipGrid,
  MatChipListbox,
  MatChipSet,
  MatDividerModule,
  MatToolbarModule,
  MatProgressSpinnerModule,
  MatFormFieldModule,
  MatSelectModule,
  MatTableModule,
  RouterModule,
  MatDatepickerModule,
  MatInputModule,
  MatSnackBarModule,
  MatExpansionModule,
  MatDialogModule,
  MatSlideToggleModule,
  MatCheckboxModule,
  MatCardModule,
  MatTabsModule,
  CdkDropListGroup,
  CdkDropList,
  CdkDrag,
];

export const LAST_USED_ORGANIZATION_STORAGE_KEY = 'last_used_sorganization';

type UnknownStringPropertiesRecursive<T> = {
  [K in keyof T]: T[K] extends string
    ? string | undefined
    : T[K] extends object
      ? UnknownStringPropertiesRecursive<T[K]>
      : T[K];
};

export function cloneWithEmptyStringsToUndefined<T>(obj: T): UnknownStringPropertiesRecursive<T> {
  let key: keyof typeof obj;
  const isArray = Array.isArray(obj);
  const result = (isArray ? [...obj] : { ...obj }) as UnknownStringPropertiesRecursive<T>;

  for (key in obj) {
    const v = obj[key];
    if (v === '') {
      delete result[key];
    } else if (typeof v === 'object' && v !== null) {
      (result[key] as unknown) = cloneWithEmptyStringsToUndefined(obj[key]);
    } else {
      (result[key] as unknown) = v;
    }
  }

  return result;
}

export const RETRY_COUNT_NORMAL = 1;
export const RETRY_COUNT_IMPORTANT = 2;
